/**
 * Reserva Belegungsplan
 */

var $ = require('jquery');
var _ = require('underscore');
var Backbone = require('backbone');
var moment = require('moment');

var DateTime = require('DateTime');
var Tooltip = require('../Tooltip');
var TemplateCache = require('TemplateCache');

var NightsCompressor = require('./NightsCompressor');
var ReservaTimeTableView = require('./ReservaTimeTableView');

var ReservaTimeTable = Backbone.Model.extend({

	defaults: function() {
		return {
			classes: [],
			from: null,
			to: null,
			model: null,
			container: null,
			viewData: null,
			renderOffset: 0,
			renderDaysCount: 31,
			cellWidth: null,
			canGoFurther: true,
			titleWidth: 0,
			selectionData: null,
			selectedNightsIndexes: [],

			/* Dev feature: Auto scrolling */
			autoGo: false,
		}
	},

	daysEncoding: {
		'.': -1, /* Empty display (not free) */
		'_': 0, /* Frei, aber kein Anreisetag */
		'1': 1,
		'2': 2,
		'3': 3,
		'4': 4,
		'5': 5,
		'6': 6,
		'7': 7,
		'8': 8,
		'9': 9,
		'A': 10,
		'B': 11,
		'C': 12,
		'D': 13,
		'E': 14,
		'F': 15,
		'G': 16,
		'H': 17,
		'I': 18,
		'J': 19,
		'K': 20,
		'L': 21,
	},

	initialize: function() {
		_.bindAll(this, "updateCellWidth");

		this.container = this.get("container");
		this.model = this.get("model");

		if ( !this.container ) {
			throw new Error(`ReservaTimeTable: Invalid container specified: ${this.container}`);
		}
		if ( this.container.length === 0 ) {
			throw new Error(`ReservaTimeTable: Container does not exist in DOM`);
		}

		this.startDay = DateTime.resetTimeFields(moment());

		this.tooltip = new Tooltip({
			className: 'reserva-timetable-tooltip',
			boxTransform: function(box) {
				/* Wir müssen die ersten 200px für die linken thead abschneiden */
				box.x1 += this.get("titleWidth");
				return box;
			}.bind(this),
		});

		this.view = new ReservaTimeTableView({
			el: this.container,
			model: this,
		});
		this.view.tooltip = this.tooltip;

		this.on('change:autoGo', function(e) {
			if ( e.attributes.autoGo ) {
				this.goInterval = window.setInterval(function() {
					if ( !e.attributes.autoGo ) return;

					var current = this.get("renderOffset");
					if ( current > 521 ) current = 0;
					this.setRenderOffset(current + 1);
				}.bind(this), 400);
			} else {
				window.clearInterval(this.goInterval);
			}
		}.bind(this));

		this.dateCache = {};
		for(var i = 0; i <= 521; i++) {
			this.dateCache[i] = this.startDay.clone().add(i, 'days');
		}

		this.on('rendered', function() {
			this.tooltip.box = this.view.$el.find('tbody');
			this.tooltip.boxHasChanged();
		});

		/* The tooltip box is a static area relative to the page. On static elements like
		   the DatePicker this is fine, but on highly dynamic pages like partner the box
		   is always moving around. So we need to listen on all render events of the miniengine */
		TemplateCache.on('render:classes-template render:products-template render:ratings-template', this.tooltip.boxHasChanged);
	},

	init: function() {
		/* Los geht's! */
		this.updateDate();

		/* Fake the data once to determine cell sizes */
		this.set("viewData", {
			months: [''],
			monthCounters: [1],
			days: ['01'],
			classes: [{ name: '', info: '', days: [{day: 1, nextDay: 1, prevDay: 1, className: 'begin'}] }],
			selectedNightsIndexes: [],
			renderDaysCount: 1,
			renderOffset: 0,
			canGoFurther: false,
			developer: false,
		});
		this.tooltip.box = this.view.$el.find('tbody');
		this.updateCellWidth();

		/* Handler registrieren (am Schluss) */
		$(window).on('resize', _.debounce(this.updateCellWidth, 500));

		this.on('change:renderOffset change:renderDaysCount', () => {
			this.updateViewState();
		});

		/* Bei Änderungen am Model die Auswahl aktualisieren */
		this.model.on('change:to change:select_mode', (e) => {
			/* Leichte Verzögerung um die UI nicht so stark zu blockieren */
			setTimeout(function() {
				this.updateDate();
				this.precalculateClasses();
				this.updateViewState();
			}.bind(this), 100);
		});
	},

	updateCellWidth: function() {
		var container = this.view.$el;

		var cellWidth = container.find('td div').parent().width();
		this.set("cellWidth", cellWidth);
		console.log("[DateDisplay] Cell width is " + cellWidth + "px");

		var titleWidth = container.find('tbody th').width();
		console.log("[DateDisplay] Title width is " + titleWidth + "px");

		var containerMaxWidth = container.width();
		var cellsToDisplay = Math.floor( ( containerMaxWidth - 200) / cellWidth ) - 1;
		this.set({
			"renderDaysCount": cellsToDisplay,
			"titleWidth": titleWidth,
		});
	},

	updateDate: function() {
		let from = this.model.get("from");
		let to = this.model.get("to");
		let select_mode = this.model.get("select_mode");
		
		/* Entweder gibt es Start UND Ende, oder gar keine Auswahl */
		if ( from && to && select_mode === "exact" ) {
			from = DateTime.resetTimeFields(DateTime.parse(from));
			to = DateTime.resetTimeFields(DateTime.parse(to));
		} else {
			from = null;
			to = null;
		}

		this.set({
			from: from,
			to: to,
			renderOffset: from ? Math.max(0, from.diff(this.startDay, 'days') - 3) : 0,
		});
	},

	handleResponse: function(response) {
		let mapping = this.daysEncoding;
		_.each(response.classes, function(klass) {
			klass.days_list = _.map(klass.days.split(''), (c) => mapping[c] );
		});
		this.set("response", response);
		this.precalculateClasses();
	},

	precalculateClasses: function() {
		/* Highlight currently selected timerange */
		let from = this.get("from");
		let to = this.get("to");
		let selectedNightsIndexes = [];
		if ( from && to ) {
			let fromIndex = Math.abs(this.startDay.diff(from, 'days'));
			let selected_nights = Math.abs(to.diff(from, 'days'));
			for(let i = 0; i < selected_nights; ++i) {
				selectedNightsIndexes.push(fromIndex + i);
			}
		}

		/* viewData vorberechnen */
		let response = this.get("response");

		let classes = [];

		if ( !response ) return;
		_.each(response.classes, (klass) => {
			let days_list = klass.days_list;
			let days = [];

			let maybePrevClass = '';
			let realPrevClass = '';

			let open = false; /* Sind wir in einem Gebiet mit freien Tagen? */
			let open2 = false; /* Sind wir in einem Gebiet mit freien Tagen, aber mit nicht-verfügbaren Anreisetagen? */
			let open3 = false; /* Sind wir in einem nicht-verfügbaren Gebiet, wo es kurz verfügbare Tage gibt? */
			_.each(days_list, function(day, i) {
				if ( i >= this.renderDaysCount ) return; /* Eins drüber */
				let date = this.dateCache[i];
				if ( !date ) {
					// In rare occasions we get more than 500 days from the API.
					date = this.startDay.clone().add(i, 'days');
					this.dateCache[i] = date;
				}

				let prevDay = i > 0 ? days_list[i - 1] : -1;
				let nextDay = i < days_list.length ? days_list[i + 1] : -1;

				let validArrival = day > 0;
				let isFree = day >= 0;

				let mainClass = '';

				/**
				 * Übersicht über die Klassen:
				 * [<] begin 	   Hellgrüner Start 
				 * [ ] free-avail  Hellgrün, kein Pfeil
				 * [ ] part2       Dunkelgrün, kein Pfeil
				 * [>] close2      Ende von hellgrünen Bereich in dunkelgrünen Bereich
				 * [<] begin2      Start in einem dunkelgrünem Bereich 
				 * [>] end         Ende in hellgrünem Bereich 
				 * [>] end2        Ende von dunkelgrünem Bereich 
				 * [o] begin3      Start von hellgrün und sofort dunkelgrün nächster Tag
				 * [o] begin4      Start von dunkelgrün und sofort dunkelgrün nächster Tag
				 */

				if ( open ) {
					/* Einfacher Fall: Tag ist verfügbar -> grün */
					if ( validArrival ) {
						mainClass = 'free-avail';
					}

					/* Falls wir offen sind, aber ab heute nicht mehr verfügbar sind: Farbe wechseln */
					if ( open3 && nextDay === 0 ) {
						mainClass = 'close2';
						open3 = false;
					}
					else if ( open2 ) {
						if ( validArrival ) {
							/* Anreisetag in sonst nicht-freier Zone */
							mainClass = 'begin2';
							open3 = true;
						} else {
							mainClass = 'part2';
						}
					}

					/* Wenn der nächste Tag kein gültiger Anreisetag - aber frei ist, wechseln wir die Farbe */
					if ( nextDay === 0 && !open2 ) {
						open2 = true;
						mainClass = 'close2';
					}

					/* Falls der Tag belegt ist, beenden wir diesen Block */
					if ( day === -1 ) {
						mainClass = open2 ? 'end2' : 'end2';
						open = false;
						open2 = false;
						open3 = false;
					}
				} else {
					if ( isFree && validArrival ) {
						/* Einzelner Anreisetag */
						if ( nextDay === 0 ) {
							mainClass = 'begin3';
							open = true;
							open2 = true;
						} else {
							/* Start einer Gruppe */
							mainClass = 'begin';
							open = true;
						}
					}
				}

				let helperClasses = [];
				if ( selectedNightsIndexes.indexOf(i) !== -1 ) helperClasses.push('selected');
				if ( open ) helperClasses.push('open');
				if ( open2 ) helperClasses.push('open2');
				if ( open3 ) helperClasses.push('open3');
				if ( validArrival ) helperClasses.push('validArrival');

				/* Overrides to fix corner cases */
				let mainClassCopy = mainClass;

				// wenn [ ][ < ][ ] Zelle sollte [o] sein
				// hellgrüne Zelle zwischen dunkelgrün
				if ( realPrevClass === "begin2" && mainClass === "part2" ) {
					days[i - 1].className = "begin4";
				}

				if ( maybePrevClass === "begin2" && mainClass === "begin2" ) {
					mainClass = "free-avail";
				}

				if ( realPrevClass === "begin2" && mainClass === "close2" && day === 0 ) {
					mainClass = "part2";
					days[i - 1].className = "begin4";
				}

				if ( mainClassCopy === "end2" && days[i - 2] && days[i - 2].className != "begin3" ) {

					if ( realPrevClass === "free-avail" ) {
						days[i - 1].className = "close2";
					} else {
						if ( open2 || prevDay === 1 ) {

							days[i - 1].className = days[i - 2].className === ( "part2" || "begin3" ) ? "begin4" : "begin3";

						} else {
							days[i - 1].className = "part2";
						}
					}

				}

				maybePrevClass = mainClassCopy;
				realPrevClass = mainClass;

				if ( date.day() === 0 || date.day() === 6 ) {
					helperClasses.push("weekend");
				}

				if ( mainClass == "" ) {
					mainClass = "occupied";
				}

				days.push({
					index: i,
					day: day,
					prevDay: prevDay,
					nextDay: nextDay,
					className: mainClass,
					maybeClass: mainClassCopy,
					helperClasses: helperClasses.join(" "),
				});
			}.bind(this));

			classes.push({
				name: klass.name,
				info: klass.info,
				/* + 1, da wir im Template einen Tag in die Zukunft sehen */
				days: days,
			});
		}.bind(this));

		this.set({
			"classes": classes,
			"selectedNightsIndexes": selectedNightsIndexes,
		})

		this.updateViewState();
	},

	setRenderOffset: function(new_offset) {
		let classes = this.get("classes");
		if ( new_offset < 0 ) {
			new_offset = 0;
		}

		if ( classes && classes[0] ) {
			let maxOffset = classes[0].days.length - this.get("renderDaysCount");
			new_offset = Math.min(new_offset, maxOffset);

			this.set({
				"renderOffset": new_offset,
				"canGoFurther": new_offset < maxOffset,
			});
		} else  {
			this.set({
				"renderOffset": 0,
				"canGoFurther": false,
			});
		}
	},

	updateViewState: function(e) {
		let renderOffset = this.get("renderOffset");
		let renderDaysCount = this.get("renderDaysCount");

		let months = [];
		let monthCounters = {};
		let days = [];

		if ( this.get("classes").length === 0 ) {
			this.set("viewData", {
				months: [],
				monthCounters: {},
				days: [],
				classes: [],
				renderDaysCount: 0,
				renderOffset: 0,
				selectedNightsIndexes: [],
				canGoFurther: false,
				developer: false,
			});
			return;
		}

		/* Make list of all days we're going to render, and group them by month */
		var makeMonths = function(short_map) {
			short_map = short_map || {};
			months = [];
			days = [];
			monthCounters = {};

			for(let i = 0; i < renderDaysCount; ++i) {
				let day	= this.startDay.clone().add(i + renderOffset, 'days');
				let monthname = day.format('MMMM YYYY');
				if ( typeof short_map[monthname] !== "undefined" ) {
					monthname = day.format(short_map[monthname]);
				}

				if ( months.indexOf(monthname) === -1 ) {
					months.push(monthname);
					monthCounters[monthname] = 0;
				}
				monthCounters[monthname]++;
				days.push({
					index: i + renderOffset,
					day: day.format('DD'),
					weekend: (day.day() === 0 || day.day() === 6),
				});
			}
		}.bind(this);
		makeMonths();

		/* Schauen ob wir die Monatsnamen kürzen müssen */
		_.each(monthCounters, function(count, month) {
			/* Wenn wir nur einen Monat haben, ist selbst "Nov." zu lang */
			if ( count === 1 ) {
				var mapping = {};
				mapping[month] = ' '; /* Achtung: Empty string führt zu YYYY-MM-DD */
				makeMonths(mapping);
			}
			/* Bei weniger als 4 Tagen kürzen wir auf z. B. "Nov." statt "November 2015" */
			else if ( count < 4 ) {
				var mapping = {};
				mapping[month] = 'MMM';
				makeMonths(mapping);
			}
		});

		/* Klassen erzeugen */
		let classes = [];
		_.each(this.get("classes"), function(klass) {
			classes.push({
				name: klass.name,
				info: klass.info,
				days: klass.days.slice(renderOffset, renderOffset + renderDaysCount),
			})
		});

		/* Alles zusammen packen und dann rendern */
		this.set("viewData", {
			months: months,
			monthCounters: monthCounters,
			days: days,
			classes: classes,
			renderDaysCount: renderDaysCount,
			renderOffset: renderOffset,
			selectedNightsIndexes: this.get("selectedNightsIndexes"),
			canGoFurther: this.get("canGoFurther"),
			developer: location.host.indexOf("localhost") !== -1,
		});
	},

	/**
	 * Handler für Events auf einzelne Zellen
	 *
	 * @param data {Object} Daten von der Zelle (classOffset, dayOffset)
	 * @param $e {jQuery} Ausgewählte Zelle
	 * @param action {String} Aktion (click, hover)
	 */
	cellAction: function(data, $e, action) {
		let days = this.get("classes")[data.classOffset].days;
		let day_data = days[data.dayOffset];
		let day = day_data.day;
		let text = "";

		let dayOffset = data.dayOffset;
		let hoverDate = this.startDay.clone().add(dayOffset, 'days');

		let validArrival = day > 0;
		let isFree = day >= 0;

		let lines = [];

		let lookAhead = function(dayOffset, day) {
			let nextOffset = dayOffset + day;
			let lookAhead;
			let nextValidNights = [];
			while ( lookAhead = days[nextOffset] ) {

				nextValidNights.push(nextOffset - dayOffset);
				nextOffset++;
				if ( (nextOffset - dayOffset) > 21 ) break;
				if ( lookAhead.day === -1 ) break;
			}
			if ( nextValidNights.length === 0 && day > 0 ) return [day];
			return nextValidNights;
		}.bind(this);

		if ( !isFree ) {
			// Kein tooltip
		} else if ( !validArrival ) {
			lines.push(hoverDate.format("dddd, DD. MMMM YYYY"));
			lines.push("Keine Anreise möglich");
			/*
			// Nach hinten schauen und prüfen, an welchen Tagen wir hätten anreisen könnten
			let nextOffset = dayOffset;
			let lookBehind;
			let prevValidDays = [];
			while ( lookBehind = days[nextOffset] ) {
				if ( lookBehind.day > 0 ) {
					let date = hoverDate.clone().subtract(dayOffset - nextOffset, 'days');
					prevValidDays.push("- " + date.format("LL"));
				}
				nextOffset--;
			}
			if ( prevValidDays.length > 0 ) {
				lines.push("Frühere Anreise möglich am:<br>" + prevValidDays.join("<br>"));
			}
			*/

		} else {
			lines.push(hoverDate.format("dddd, DD. MMMM YYYY"));

			/* Nach vorne schauen und prüfen, an welchen Tagen wir noch anreisen könnten */
			let nextValidNights = lookAhead(dayOffset, day);
			let text = "Anreise möglich für " + NightsCompressor.humanString(nextValidNights);
			lines.push(text);
		}

		// Erstmal alle Selection-Klassen löschen
		this.view.$el.find('.selection').removeClass('selection select-start select-part select-end selection-valid selection-invalid');

		if ( action === "click" ) {

			let selectionData = this.get("selectionData");
			let select_start = true;

			if ( selectionData ) {
				/* Der User hat bereits geklickt und will seine Auswahl vollenden */
				select_start = false;

				/* Falls es die gleiche Klasse ist, nehmen wir die Auswahl an. Ansonsten wird eine neue gestartet. */
				if ( selectionData.classOffset === data.classOffset ) {
					let from = this.startDay.clone().add(selectionData.dayOffset, 'days');
					let to = this.startDay.clone().add(data.dayOffset, 'days');

					let nightsCount = data.dayOffset - selectionData.dayOffset;
					let valid = selectionData.lookAhead.indexOf(nightsCount) !== -1;
					if ( valid ) {
						console.log("Setting selection to", from.format("YYYY-MM-DD"), "=>", to.format("YYYY-MM-DD"));
						this.trigger("dateSelected", from, to);
					}

				} else {
					select_start = true;
				}
				this.set("selectionData", null);
			}

			if ( select_start ) {
				if ( day > 0 ) {
					data.lookAhead = lookAhead(dayOffset, day);
					data.tooltip = "Anreise möglich für " + NightsCompressor.humanString(data.lookAhead);
					data.startDay = hoverDate;
					this.set("selectionData", data);
				} else if ( day === -1 ) {
					lines = ["Unterkunft ist an diesem Tag bereits belegt."];
				}
			}
		}

		text = lines.join("<br>");

		let selectionData = this.get("selectionData");
		if ( selectionData && selectionData.classOffset === data.classOffset ) {
			let nightsCount = data.dayOffset - selectionData.dayOffset;
			nightsCount = Math.max(nightsCount,  0);

			let valid = selectionData.lookAhead.indexOf(nightsCount) !== -1;
			let validClass = 'selection-' + (valid ? 'valid' : 'invalid') + ' ';

			lines = [];
			lines.push('<span class="selection-info ' + validClass + '">');
			lines.push(DateTime.textPeriod(selectionData.startDay, hoverDate));
			lines.push('<br>');

			if ( nightsCount > 21 ) {
				lines.push("Mehr als 21 Nächte ausgewählt");
			} else if ( nightsCount === 0 ) {
				lines.push("Bitte Abreisetag auswählen");
			} else if ( !valid ) {
				lines.push(selectionData.tooltip);
			}
			lines.push('</span>')

			if ( selectionData.dayOffset === data.dayOffset ) {
				$e.addClass('selection ' + validClass + 'select-start');
			} else {
				for(var i = selectionData.dayOffset; i <= data.dayOffset; i++) {
					let klass = 'select-part';
					if ( i === selectionData.dayOffset ) klass = 'select-start';
					if ( i === data.dayOffset ) klass = 'select-end';

					this.view.$el.find('.cell_' + data.classOffset + '_' + i).addClass('selection ' + validClass + klass);
				}
			}

			text = lines.join("");
		}

		if ( lines.length > 0 ) {
			if ( location.hostname === "localhost" ) {
				text += "<br><i>index(" + day_data.index + ") prev(" + day_data.prevDay + ") day(" + day_data.day + ") next(" + day_data.nextDay + ") mainClass(" + day_data.className + ") maybeClass(" + day_data.maybeClass + ") helperClasses(" + day_data.helperClasses + ")</i>";
			}

			this.tooltip.set(text);
		} else {
			this.tooltip.hide();
		}
	},

});



module.exports = ReservaTimeTable;



/** WEBPACK FOOTER **
 ** /Users/mitch/jsapps/modules/reserva/miniengine/ReservaTimeTable.js
 **/